var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "return-table" },
    [
      _c(
        "el-table",
        {
          staticStyle: { margin: "0", "border-collapse": "collapse" },
          attrs: {
            "header-cell-class-name": "order-table-header",
            "show-header": true,
            data: _vm.returns,
          },
        },
        [
          _c("el-table-column", {
            attrs: { sortable: "", prop: "return_id", label: "Return#" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-family": "Equip",
                          "text-decoration": "underline",
                        },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.setCurrentReturn(props.row.return_id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          #" +
                            _vm._s(props.row.return_id) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "Return Created On" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("time-zone-formatter", {
                      attrs: {
                        "current-time": props.row.created_at,
                        "output-format": "MMM D, YYYY",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "source", label: "Source" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tag", [
                      _vm._v(_vm._s(_vm.displaySource(scope.row))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "state", label: "Status" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("ReturnStatus", {
                      attrs: { "order-status": scope.row.state },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "return_received", label: "Return Received" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("time-zone-formatter", {
                      attrs: {
                        "current-time": props.row.return_received,
                        "output-format": "MMM D, YYYY",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "item_quantity", label: "Items" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }